import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

export enum LoaderState {
    Shown = 'Shown',
    Hidden = 'Hidden'
}

@Injectable()
export class FullPageLoader {
    private static readonly loader = new ReplaySubject<LoaderState>();

    public static subscribeToLoaderInstructions(observer: (value: LoaderState) => void): void {
        FullPageLoader.loader.subscribe(observer);
    }

    public showLoader(): void {
        FullPageLoader.loader.next(LoaderState.Shown);
    }

    public hideLoader(): void {
        FullPageLoader.loader.next(LoaderState.Hidden);
    }
}